//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/DisplayableObject.js";
import "../no/ugmath.js";
let d=[[[0,"AssociatedBody",0,"Body",0],[0,"BodyType",0,0],[0,"IsAssemblyLevel",0,0],[0,"IsAssociatedBodyLoaded",0,0],[0,"IsSheetBody",0,1],[0,"IsSolidBody",0,1],[0,"NumberOfFaces",0,0],[0,"NumberOfLevelsOfDetail",0,0],[0,"SurfaceArea",0,0],[0,"Volume",0,0]],[[["level_of_detail"],"GetNumberOfFacets",{R_:{count:''}},1,0],[["number_of_faces"],"GetFaces",{R_:{faceted_face:"Facet.FacetedFace[]"}},0,0],[[],"GetNumberOfEdges",{R_:{number_of_edges:''}},0,0],[["number_of_edges"],"GetEdges",{R_:{edges:"Facet.FacetedEdge[]"}},0,0],[[],"HasTopologyInformation",{R_:{has_topology_information:''}},0,0],[[],"HasLightWeightAnalytics",{R_:{has_lightweight_analytics:''}},0,0],[[],"GetParameters",{R_:{parameters:''}},0,0],[["parameters"],"SetParameters",{},1,0],[[],"DestroyOwnedFacets",{},0,0]],[]];
SPLM.Facet.FacetedBody = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.FacetedBody";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.FacetedBody.FacetedbodyType = Object.freeze({
    "Undefined" : "Undefined", "SolidBody" : "SolidBody", "SheetBody" : "SheetBody"});

export default SPLM;